import { useSuspenseQuery } from "@tanstack/react-query";
import { listAllEvents } from "../openapi/api-client.ts";
import { ListEventsError } from "../errors/ListEventsError.ts";

export const useListEvents = () =>
  useSuspenseQuery({
    queryKey: ["events"],
    queryFn: async () => {
      const response = await listAllEvents({});

      if (!response.data) {
        throw new ListEventsError(
          `error while fetching app installations: ${response.error.message}`,
        );
      }

      return response.data;
    },
  });
